import { useWatchTable } from '@/src/hooks/data/useGameTable';
import styles from './A23WatchTimer.module.css'
import { useEffect } from 'react';
import { TIMER_REMOVED } from '../../../../Poker/data/Constants';
import { useTimerData } from '@/src/hooks/data/useTimerData';

const A23WatchTimer = (props) => {
    const { tempTableId } = props;
    const watchTimerId = "watch-timer-" + tempTableId;
    const watchTable = useWatchTable(tempTableId);
    const { timer, closeSocket, hideTimer, status } = watchTable || {};
    const { value, status: timerStatus } = useTimerData(watchTimerId);

    // useEffect(() => { //reference purpose to pause at unmount and resume at mount
    //     const timerWorker = getTimerWorkerInstance();
    //     timerWorker.postMessage({
    //         type: "resume",
    //         timerId: watchTimerId,
    //     });

    //     return () => {
    //         timerWorker.postMessage({
    //             type: "pause",
    //             timerId: watchTimerId,
    //         });
    //     };
    // }, [watchTimerId]);


    // useEffect(() => {
    //     if (status === TIMER_REMOVED) {
    //         cancel();
    //     }
    // }, [status])


    if (!hideTimer && value > 0) {
        return (
            <div className={styles.watchTimerContainer}>
                Table closing in <span className={styles.timerText}> {` ${value} sec.`} </span>&nbsp;Take a seat now.
            </div>
        );
    }
    return null;
}

export default A23WatchTimer;